import React, { useEffect, useState } from "react";
import { Button, Modal, ModalBody, Spinner } from "reactstrap";
import { setAnalyticsEvent } from "../../core/helpers/analytics";
import { initializeGTM, sendGTMEvent } from "../../core/helpers/gtm";
import { initBranch, trackEvent } from "../../core/helpers/branchio";
import ReactPixel from "react-facebook-pixel";

const CashfreePaymentStatus = (props) => {
  const {
    investmentAmount,
    data,
    isOpen,
    toggleModal,
    retrySubmitOrderAtExchange,
    setpaymentMethod,
    isAdvisory,
    redirectToPartner,
    product,
    thirdPartyData
  } = props;
  const [retry, setRetry] = useState(false);


  useEffect(() => {
    initializeGTM();
    ReactPixel.init("1402347907589394");
  
    if (isOpen && data?.status === "success") {
      const eventName = "Cashfree_Payment_Done";
      console.log("eventName", eventName);

      // Trigger Analytics
      if (process.env.REACT_APP_RENDER_GA === "true") {
        setAnalyticsEvent(eventName);
      }

      sendGTMEvent("Bond_Payment_Done_GTM", {
        email: thirdPartyData?.email || "",
        value: investmentAmount?.amount || 0,
        currency: "INR",
      });

      sendGTMEvent(`Bond_Payment_Done_${product}_GTM `, {
        email: thirdPartyData?.email || "",
        value: investmentAmount?.amount || 0,
        currency: "INR",
      });
      // Trigger Branch event
      initBranch()
        .then(() =>
          trackEvent(
            "Bidd_payment_done",
            thirdPartyData?.email || "",
            thirdPartyData?.phone || "",
            thirdPartyData?.userId || "",
            investmentAmount?.amount || 0,
          )
        )
        .catch((error) => console.error("Error initializing Branch:", error));

      initBranch()
        .then(() =>
          trackEvent(
            `Bidd_payment_done_${product}`,
            thirdPartyData?.email || "",
            thirdPartyData?.phone || "",
            thirdPartyData?.userId || "",
            investmentAmount?.amount || 0,
          )
        )
        .catch((error) => console.error("Error initializing Branch:", error));

      ReactPixel.track("Bond_Payment_Done_Pixel", {
        value: investmentAmount?.amount || 0,
        currency: "INR",
      });
      ReactPixel.track(`Bond_Payment_Done_${product}_Pixel`, {
        value: investmentAmount?.amount || 0,
        currency: "INR",
      });
    }

    if(isOpen && data?.status === "failed") {
      initBranch()
        .then(() => trackEvent("Bidd_Payment_Failed",
          thirdPartyData?.email || "",
          thirdPartyData?.phone || "",
          thirdPartyData?.userId || "",))
        .catch((error) => console.error("Error initializing Branch:", error));
    }
  }, []);

  const fnSetRetry = (param) => {
    setRetry(param);
    data.retry = param;
  };

  const handleButtonClick = () => {
    setpaymentMethod("upi");
    toggleModal(false);
  };

  return (
    <>
      <Modal isOpen={isOpen} centered className="cf-payment-status-popup">
        <ModalBody className="m-auto text-center" style={{ minWidth: "400px" }}>
          <img
            className="img-icon mt-3"
            src={
              data.status === "success" ||
              data.status === "pending" ||
              data.status === "onhold"
                ? process.env.REACT_APP_IMAGES_PATH + "success1.webp"
                : process.env.REACT_APP_IMAGES_PATH + "failure_1.webp"
            }
            alt="result-icon"
          />

          <h5 className="title">{data.title}</h5>

          {data.message && (
            <div
              className={
                "content " +
                (data.status == "success"
                  ? "success"
                  : data.status == "failed"
                  ? "failed"
                  : "")
              }
              dangerouslySetInnerHTML={{ __html: data.message }}
            ></div>
          )}

          {data.orderId && !isAdvisory && (
            <p className="order-id">Order Id : {data.orderId}</p>
          )}

          <div className="c-btn">
            {data.spinner && (
              <div className="c-spinner">
                <Spinner size="sm" color="secondary" />
              </div>
            )}
            {data.note && (
              <p
                className="note"
                dangerouslySetInnerHTML={{ __html: data.note }}
              ></p>
            )}

            {data.sendToExchange && data.count <= 2 && data.status == "failed" && (
              <Button
                size="md"
                color={"link"}
                onClick={() => {
                  fnSetRetry(true);
                  retrySubmitOrderAtExchange();
                }}
                className="btn-retry"
                disabled={retry && data.retry}
              >
                <div className="re-try">
                  Retry
                  {retry && data.retry && (
                    <div className="c-retry-spinner">
                      <Spinner size="sm" color="white" />
                    </div>
                  )}
                </div>
              </Button>
            )}
            {data.showCloseBtn && (
              <Button
                size="md"
                color={"link"}
                onClick={() => {
                  if (isAdvisory) {
                    if (
                      (data.status === "pending" || data.status === "onhold") &&
                      data.sendToExchange === false
                    ) {
                      redirectToPartner(true, "success", data.orderId); // In case fo NEFT payment (as its status always be 'pending')
                    } else {
                      redirectToPartner(true, data.status, data.orderId);
                    }
                  } else {
                    if (data.reloadPage) {
                      window.location.reload();
                    } else if (data.redirectWithCleanParams) {
                      window.location.href = data.redirectWithCleanParams;
                      window.location.reload();
                    } else {
                      handleButtonClick();
                    }
                  }
                }}
              >
                Close
              </Button>
            )}
          </div>
        </ModalBody>
      </Modal>

      {/* <div class="bg-gray-100 h-screen">
            <div class="bg-white p-6  md:mx-auto">
                
                <div class="text-center">
                    <h3 class="md:text-2xl text-base text-gray-900 font-semibold text-center">Payment Done!</h3>
                    <p class="text-gray-600 my-2">Thank you for completing your secure online payment.</p>
                    <p> Have a great day!  </p>
                    <div class="py-10 text-center">
                        <a href="#" class="px-12 bg-indigo-600 hover:bg-indigo-500 text-white font-semibold py-3">
                            GO BACK
                        </a>
                    </div>
                </div>
            </div>
        </div> */}
    </>
  );
};

export default CashfreePaymentStatus;
